import DealerReviewComparision from "../../../Components/Table/DealerReviewComparision";

const Realization_Comparision = () => {
  return (
    <div className="bg-white shadow-lg text-xs rounded-lg w-full relative h-full">
      <h2 className="text-lg font-bold text-gray-800  p-2">
        Realization Comparision
      </h2>
      <DealerReviewComparision
        endpoint="dealer-review/realization_comparision"
        expansionEndpoint="dealer-review/realization_lob_wise_comaprision"
      />
    </div>
  );
};

export default Realization_Comparision;
